import React from 'react';
import { Button, ButtonProps, Form, Input } from 'antd';
import styled from 'styled-components';
import DefaultModal from '../organisms/DefaultModal';
import ButtonFull from '../atoms/ButtonFull';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../services/context/AuthContext';
import { validateCPF } from '../../services/util/validator';
import { FormInstance } from 'antd/lib/form';
import  usersRepository  from '../../services/repository/users';


const Wrapper = styled.div`
    padding: 32px;
    margin-top: 32px;
`;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
};

// Create a new type excluding 'form' from ButtonProps
type ButtonPropsWithoutForm = Omit<ButtonProps, 'form'>;

interface SubmitButtonProps extends ButtonPropsWithoutForm {
  form: FormInstance;
}

const SubmitButton: React.FC<React.PropsWithChildren<SubmitButtonProps>> = ({ form, children, ...rest }) => {
  const [submittable, setSubmittable] = React.useState<boolean>(false);

  // Watch all values
  const values = Form.useWatch([], form);

  React.useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);

  return (
    <Button type='primary' htmlType='submit' disabled={!submittable} {...rest}>
      {children}
    </Button>
  );
};


const CustomSubmitButtonProps = styled(SubmitButton)`
    width: 100%
`;

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { login } = useAuth();


  const handleChangeCPF = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    const maskedValue = value
      .replace(/\D/g, '') // Remove caracteres não numéricos
      .replace(/(\d{3})(\d)/, '$1.$2') // Insere o primeiro ponto
      .replace(/(\d{3})(\d)/, '$1.$2') // Insere o segundo ponto
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2'); // Insere o hífen
    form.setFieldsValue({ username: maskedValue });
  };

  return (
    <DefaultModal width={384} showBtnExit={false} squareWidth={'80%'}>
      <Wrapper>
        <Form form={form} {...formItemLayout} style={{ maxWidth: 600 }} requiredMark={false} layout='vertical'
          name='validateOnly'>
          <Form.Item label='Login' name='username' rules={[
            {
              validator: validateCPF,
              required: true,
            }]}>
            <Input placeholder='Digite aqui' onChange={handleChangeCPF} maxLength={14} />
          </Form.Item>

          <Form.Item
            label='Senha'
            name='password'
            rules={[{ required: true }]}
          >
            <Input.Password placeholder={'********'} />
          </Form.Item>

          <Form.Item>
            <CustomSubmitButtonProps form={form} onClick={() => {
              login(form.getFieldValue('username'), form.getFieldValue('password')).then((response) => {
                if (response?.status === 200) {
                  usersRepository.getCurrentUserAdmissionMetaData(true).then(() => {
                    navigate('info-access');
                  });
                }
              });
            }}>Acessar</CustomSubmitButtonProps>
          </Form.Item>

          <Form.Item>
            <ButtonFull onClick={() => navigate('/forgot-password')}>Esqueceu a senha?</ButtonFull>
          </Form.Item>
        </Form>
      </Wrapper>
    </DefaultModal>
  );
};

export default Login;
